import { useParams } from "react-router-dom";
import { accountText } from "./_accountText";
export default function Account(){const {lang}=useParams(); const x=accountText(lang); return <div><h1 className="text-2xl font-black">{x.overview}</h1><p className="mt-2 text-slate-600">{x.overviewBody}</p></div>;}
